import React from 'react';
import { TinyMCE as TinyMCEComponent } from '@fourthwall/components';
import { useAppearance } from '@fourthwall/appearance';
export const TinyMCE = (props) => {
    const { appearance } = useAppearance();
    return (React.createElement(TinyMCEComponent, { tinymceScriptSrc: `${process.env.PUBLIC_PATH}public/tinymce/tinymce.min.js`, appearance: appearance, ...props }));
};
